<template>
  <div
    v-click-outside="closeLayout"
    class="user-profile"
    :class="{ 'toggled': toggled, 'small': !allowAccess }">

    <!-- Short user info -->
    <div class="top-wrapper">
      <div class="user-wrapper">
        <div class="user-photo"></div>
        <div class="user-info">
          <div class="user-name">{{ userName }}</div>
          <div class="user-type">{{ user.user_type }}</div>
        </div>
      </div>

      <!-- Open extend info button -->
      <div @click="toggle" class="more-btn">
        <span class="dot tr"></span>
        <span class="dot"></span>
        <span class="dot tr"></span>
      </div>
    </div>

    <!-- Extend info -->
    <div class="elements-wrapper">
      <div class="item" @click="modals.showSettingsUser = true">
        <span class="i-util-settings"></span>
        <span class="label">{{ 'base.settings' | translate }}</span>
      </div>

    <v-dialog
      max-width="350"
      v-model="modals.showSettingsUser">
      <settings-user-modal
        @close="modals.showSettingsUser = false"/>
    </v-dialog>

      <!-- Admin section -->
      <div v-if="allowAccess" class="menu-items">
        <router-link
          v-for="item in menuItems"
          :key="item.id"
          :to="item.path"
          class="item"
          @click.native="closeLayout">
          <svg class="icon">
            <use :xlink:href="`/svg/sprite.svg#${item.icon}`"/>
          </svg>
          <span class="label">{{ item.title | translate }}</span>
        </router-link>
      </div>

      <!-- Logout -->
      <div @click="logout" class="item item-exit">
        <span class="i-admin-logout"></span>
        <span class="label">{{ 'base.logout' | translate }}</span>
      </div>
    </div>

    <div class="footer">
      <div class="footer--item">{{ appVersion }} | {{ updateDate }}</div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import {ADMIN_SIDEBAR, EMPLOYEE_SIDEBAR, LANG_VAR_LOCAL_STORAGE_KEY} from '@/util/consts.js'

import SettingsUserModal from './modals/SettingsUserModal'

export default {
  name: 'ClientsPanels',

  components: {
    SettingsUserModal
  },

  mounted () {
    this.loadData()
    // this.$store.dispatch('setProfileUpdater', this.loadData)
  },
  created () {
    this.menuItems = this.processMenuItems(ADMIN_SIDEBAR)
  },
  data: (vm) => ({
    toggled: false,
    menuItems: [],
    user: {
      first_name: '',
      last_name: '',
      photo: '',
      user_type: ''
    },
    modals: {
      showSettingsUser: false
    }
  }),

  methods: {
    async loadData () {
      const { data } = await api.account.get()
      this.user.first_name = data.first_name
      this.user.last_name = data.last_name
      this.user.photo = data.photo
      this.user.user_type = data.user_type

      if (data.user_type === 'employee') {
        this.menuItems = this.processMenuItems(EMPLOYEE_SIDEBAR)
      }
      const lang = localStorage.getItem(LANG_VAR_LOCAL_STORAGE_KEY) || data.profile.language
      await this.$store.dispatch('account/setLang', lang)

      if (localStorage.getItem(LANG_VAR_LOCAL_STORAGE_KEY) !== data.profile.language) {
        api.account.update({profile: {language: lang}})
      }
    },
    processMenuItems (items) {
      return items
        .map(item => {
          const clientId = this.$route.params.client_id
          const path = clientId
            ? `/app/clients/${clientId}/admin/${item.path}`
            : `/app/admin/${item.path}`
          return {
            ...item,
            path
          }
        })
        .filter(item => item.title !== 'base.blanks')
    },
    toggle () {
      this.toggled = !this.toggled
    },

    openSettingsDialog () {
      this.toggled = false
      this.$emit('open')
    },

    closeLayout () {
      if (this.toggled) {
        this.toggled = false
      }
    },

    logout () {
      this.$store.dispatch('account/logout')
      this.$router.push('/auth')
    }
  },

  computed: {
    allowAccess () {
      return this.isClient || this.isAdmin || this.isStaff
    },

    userName () {
      const name = this.user.first_name + ' ' + this.user.last_name
      return name.length > 12 ? name.substring(0, 12) + '...' : name
    },

    updateDate () {
      return process.env.VUE_APP_UPDATE_DATE || 'mode'
    },

    appVersion () {
      return process.env.VUE_APP_VERSION || 'dev'
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-profile {
    position: absolute;
    top: 0;
    right: 0;
    height: 71px;
    width: 295px;
    padding-top: 1rem;
    padding-left: 4.5rem;
    transition: .4s;
    overflow: hidden;
    z-index: 600;
    border-bottom-left-radius: 1rem;
  }

  .icon {
    height: 25px;
    width: 25px;
  }

  .user-profile.toggled {
    background: #fff;
    height: 580px;
    width: 328px;
    padding-top: 45px;
    box-shadow: 0 1px 14px 0 rgba(0, 0, 0, 0.19);
  }

  .user-profile.toggled.small {
    height: 355px;
  }

  .top-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 25px;
  }

  .more-btn {
    cursor: pointer;
    width: 14px;
    display: inline-block;
    padding-left: 10px;
  }

  .more-btn .dot {
    display: block;
    height: 4px;
    width: 4px;
    margin: 4px 0;
    border-radius: 50%;
    background: #898989;
    transform: translateX(0);
    transition: .5s;
  }

  .user-profile.toggled .dot {
    background: #111;
  }

  .user-profile.toggled .dot.tr {
    transform: translateX(-10px);
  }

  .user-info {
    transform: translate(0, -9px);
  }

  .user-info,
  .user-photo {
    display: inline-block;
  }

  .user-info .user-name {
    padding-top: 6px;
    color: #233c47;
    font-size: 14px;
    font-weight: 700;
  }

  .user-info .user-type {
    padding-top: 2px;
    color: #3f5c66;
    font-size: 13px;
  }

  .user-photo {
    height: 46px;
    width: 46px;
    margin-right: 15px;
    border-radius: 50%;
    background: #233c47;
  }

  .elements-wrapper {
    opacity: 0;
    display: flex;
    flex-direction: column;
    transition: .5s;
    padding-top: 35px;
  }

  .elements-wrapper .menu-items {
    margin: 30px 0;
  }

  .elements-wrapper .item {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 33px;
  }

  .elements-wrapper .item:hover {
    text-decoration: underline;
  }

  .elements-wrapper .item .label {
    font-size: 15px;
    margin-left: 2.4rem;
  }

  .user-profile.toggled .elements-wrapper {
    opacity: 1;
  }

  .footer--item {
    font-size: 13px;
    font-weight: 300;
  }
</style>
